module.exports = "/images/tr.svg?dbae70d70febdb23825ea09cebd2e027";